// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://itgpqcajiwjpsfrmuagg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0Z3BxY2FqaXdqcHNmcm11YWdnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc1MDIzMTQsImV4cCI6MjA3MzA3ODMxNH0.GVHkhYTJYHmUDrQAWtMUkwDyt74ze_2UEqie4gSe7jI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});